import React, { Component } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import DownloadBtn from './DownloadBtn'
import './style.css'
import Classes from './commonstyle.module.css'
import { Modal } from 'react-bootstrap'
import ComboBox from './Combobox'
import Badge from '@mui/material/Badge';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import DensityLargeIcon from '@mui/icons-material/DensityLarge';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


const operations = [
    { value: 'Containing', label: 'Containing' },
    { value: 'Not Containing', label: 'Not Containing' },
    { value: 'Ending With', label: 'Ending With' },
    { value: 'Not Ending With', label: 'Not Ending With' },
    { value: 'Equal to', label: 'Equal to' },
    { value: 'Not Equal to', label: 'Not Equal to' },
    { value: 'Starting With', label: 'Starting With' },
    { value: 'Not Starting With', label: 'Not Starting With' },
]
export default class Nav extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isShowSearchBox: false, searchValue: '', isOpenFilterModal: false,
            selectedColumnObj: '', allColumns: [], selectedOperationObj: '', value: '', isFilterApplied: false,selectedDensity:1,
            dense: null, allDensity: [
                {
                    name: "Comfort",
                    icon: <DensitySmallIcon />,
                    value: 1,
                    selected: true
                },
                {
                    name: "Standard",
                    icon: <DensityMediumIcon />,
                    value: 2,
                    selected: false
                },
                {
                    name: "Comfortable",
                    icon: <DensityLargeIcon />,
                    value: 3,
                    selected: false
                }
            ]
        }
        this.onSearch = this.onSearch.bind(this)
        this.clearSearch = this.clearSearch.bind(this)
    }
    // componentDidMount(){
    // }
    onSearch(e) {
        this.setState({ searchValue: e.target.value }, () => {
            this.props.onSearchChange(e.target.value)
        })
    }
    clearSearch(e) {
        this.setState({ isShowSearchBox: false, searchValue: '' }, () => {
            this.props.onClearSearch()
        })
    }
    onFilterBtnClick() {
        this.setState({ isOpenFilterModal: true })
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isTableDataFound != this.props.isTableDataFound && this.props.columns.length > 0) {
            let columns = []
            for (const key of Object.keys(this.props.columns[0])) {
                let obj = {
                    value: key,
                    label: key
                }
                columns.push(obj)
            }
            // console.log(columns)
            this.setState({ allColumns: columns })
        }
    }
    onClearFilter() {
        this.setState({ selectedColumnObj: '', selectedOperationObj: '', value: '', isOpenFilterModal: false, isFilterApplied: false }, () => {
            this.props.onClearFilter()
        })
    }
    onApplyFilter() {
        let error = ''
        if (this.state.selectedColumnObj == "") {
            error = 'Please select column'
        } else
            if (this.state.selectedOperationObj == "") {
                error = 'Please select operation'
            }
        if (error == "") {
            this.setState({ isOpenFilterModal: false, isFilterApplied: true }, () => {
                this.props.onApplyFilter(this.state.selectedColumnObj.value, this.state.selectedOperationObj.value, this.state.value)
            })
        } else {
            alert(error)
        }
    }
    onDensitySelect(density) {
        this.setState({ selectedDensity: density.value, dense: null }, () => {
            // this.setState({allDensity:})
            const {allDensity} = this.state
            allDensity.forEach((dense) => density.value == dense.value ? dense.selected = true : dense.selected = false)
            console.log(this.state.allDensity)
            this.props.onDensitySelect(density.value)
        })
    }
    render() {
        return (
            <>
                <div className='navbar'>
                    <div className="leftdiv">
                        {
                            this.props.navbar.isBackBtn &&
                            <Tooltip title="Go Back">
                                <IconButton onClick={(e) => this.props.navbar.callbacks.onBackBtn && this.props.navbar.callbacks.onBackBtn(e)}>
                                    <ArrowBackIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        <span style={{ paddingLeft: "8px" }}>{this.props.navbar.heading}</span>
                    </div>
                    <div className="rightdiv">
                        {
                            this.props.navbar.Actions
                        }
                        {
                            this.props.navbar.isSearchBtn &&
                            <>
                                <input type="text" id="searchBarFocus" autoFocus={true} value={this.state.searchValue} style={{ width: this.state.isShowSearchBox ? "250px" : '0px', padding: this.state.isShowSearchBox ? "6px 12px" : "6px 0px", marginLeft: this.state.isShowSearchBox ? "10px" : '0px' }} className="editable" placeholder='Search...' onChange={(e) => this.onSearch(e)} />
                                {
                                    this.state.isShowSearchBox ?
                                        <Tooltip title="Close Search">
                                            <IconButton onClick={() => this.clearSearch()}>
                                                <CloseIcon />
                                            </IconButton>
                                        </Tooltip>

                                        :
                                        <Tooltip title="Open Search">
                                            <IconButton onClick={() => this.setState({ isShowSearchBox: true }, () => {
                                                if (document.getElementById('searchBarFocus')) {
                                                    document.getElementById('searchBarFocus').focus()
                                                }
                                            })}>
                                                <SearchIcon />
                                            </IconButton>
                                        </Tooltip>

                                }

                            </>
                        }
                        {
                            this.props.navbar.isDownloadBtn &&
                            <DownloadBtn
                                options={this.props.navbar.downloadOptions}
                                onDownload={(option) => this.props.onDownload(option)}
                            />
                        }
                        {
                            this.props.navbar.isDenseBtn &&
                            <>
                                <Tooltip title='Dense'>
                                    <IconButton
                                        id="demo-positioned-button"
                                        aria-controls={Boolean(this.state.dense) ? 'demo-positioned-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={Boolean(this.state.dense) ? 'true' : undefined}
                                        onClick={(e) => this.setState({ dense: e.currentTarget })}
                                    >
                                        {
                                            this.state.allDensity.map((density) => {
                                                if(density.selected){
                                                    return (
                                                        density.icon
                                                    )
                                                }
                                            })
                                        }
                                    </IconButton>
                                </Tooltip>
                                <Menu
                                    id="demo-positioned-menu"
                                    aria-labelledby="demo-positioned-button"
                                    anchorEl={this.state.dense}
                                    open={Boolean(this.state.dense)}
                                    onClose={() => this.setState({ dense: null })}
                                    elevation={0}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                >
                                    {
                                        this.state.allDensity.map((density) => {
                                            return (
                                                <MenuItem divider={true} selected={density.value == this.state.selectedDensity ? true : false} key={density.value} onClick={() => this.onDensitySelect(density)}>{density.icon} &nbsp;&nbsp;&nbsp;{density.name}</MenuItem>
                                            )
                                        })
                                    }
                                </Menu>
                            </>
                        }
                        {
                            this.props.navbar.isFilterBtn &&
                            <Tooltip title='Filter'>
                                <IconButton onClick={() => this.onFilterBtnClick()}>
                                    {
                                        this.state.isFilterApplied ?
                                            <Badge badgeContent={1} color="primary">
                                                <FilterAltIcon />
                                            </Badge>
                                            :
                                            <FilterAltIcon />
                                    }
                                </IconButton>
                            </Tooltip>

                        }
                    </div>
                </div>
                <Modal size="lg" centered animation={true} style={{ background: "rgba(0,0,0,0.5)" }} show={this.state.isOpenFilterModal} onHide={() => this.setState({ isOpenFilterModal: false })} backdrop="static" keyboard={false}> {/* backdrop="static" keyboard={false} */}
                    <Modal.Body>
                        <div className="filter_box">
                            <div className="header">
                                <Tooltip title='Close view'>
                                    <IconButton onClick={() => this.setState({ isOpenFilterModal: false })}>
                                        <CloseIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                            <div className="row" style={{ width: "100%", borderBottom: "1px solid rgba(0,0,0,0.05)", paddingBottom: "10px" }}>
                                <div className="col-md-4">
                                    <label htmlFor="column">Column</label>
                                    <ComboBox
                                        value={this.state.selectedColumnObj}
                                        options={this.state.allColumns}
                                        onChange={obj => this.setState({ selectedColumnObj: obj })}
                                        placeholder={"Select column title"}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="column">Operation</label>
                                    <ComboBox
                                        value={this.state.selectedOperationObj}
                                        options={operations}
                                        onChange={obj => this.setState({ selectedOperationObj: obj })}
                                        placeholder={"Select operation"}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="column">Value</label>
                                    <input type="text" className='form-control' value={this.state.value} onChange={(e) => this.setState({ value: e.target.value })} />
                                </div>
                            </div>
                            <div className="footer">
                                <span onClick={() => this.onApplyFilter()}>Apply Filter</span>
                                <span onClick={() => this.onClearFilter()}>Clear Filter</span>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        )
    }
}
